import DatePicker from "./component";
import { asVariation } from "../../../helper/variations";

DatePicker.Primary = asVariation(DatePicker, "primary", {
  typeStyle: "primary",
});

export { DatePicker };
